import React from 'react';
import classnames from 'classnames';
import ReactHtmlParser from 'react-html-parser';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { repiActions } from '../../../store/repiStore';
import { isNullOrUndefined, isString, isEmpty } from '../../../store/storeFunctions';
import BbDatePicker from '../../common/datePicker';
import CustomTooltip from '../../common/customTooltip';

class RepiSearchInput extends React.Component {
    render() {
        const { name, label, formik, isRequired, disabled, noMaxDate } = this.props;
        const value = formik.values[name];
        const hasError = !isNullOrUndefined(formik.errors[name]);
        const errorText = hasError ? ReactHtmlParser(this.getErrorMessage(formik.errors[name])) : "";
        const isMinCriteria = this.isMinCriteriaError(formik.errors[name]);

        return (
            <div className="repi-search-input-row repi-search-flex">
                <div className="field bb-field" style={{ marginBottom: "0px" }}>
                    <label>{label}</label>{isRequired ? <span className="repi-search-input-star"> *</span> : null}
                    <div className="control" data-error={hasError ? "true" : "false"}>
                        {this.props.isDate ? <BbDatePicker useShadowOnError
                            id={name}
                            value={value || ""}
                            field={name}
                            formDateFormat={"YYYY-MM-DD"}
                            yearsBack={120}
                            formik={formik}
                            hasValidationError={this.canHighlightError()}
                            additionalClasses={{ "has-min-criteria-error": this.canHighlightError() && isMinCriteria }}
                            onFocus={() => this.onFocus(true)}
                            onBlur={() => this.onFocus(false)}
                            disabled={disabled === true}
                            noMaxDate={noMaxDate === true}
                        /> : <input
                            className={classnames("input form-control", {
                                "is-invalid": this.canHighlightError(),
                                "has-min-criteria-error": this.canHighlightError() && isMinCriteria
                            })}
                            name={name}
                            id={name}
                            value={value}
                            onChange={this.onChange}
                            onFocus={() => this.onFocus(true)}
                            onBlur={() => this.onFocus(false)}
                            disabled={disabled === true}
                        />}
                    </div>
                </div>
                {hasError && !isEmpty(errorText) && <CustomTooltip hideIcon
                    textAlign="right"
                    placement="bottom"
                    id={name}
                    text={errorText}
                    innerClassName="repi-search-input-error-tooltip"
                />}
            </div>
        );
    }

    onChange = (e) => {
        let value = e;

        if (!isNullOrUndefined(e.target))
            value = e.target.value;
        else if (!isNullOrUndefined(e.value))
            value = e.value;
        else if (isNullOrUndefined(value))
            value = "";

        this.props.formik.setFieldValue(this.props.name, value);
    }

    onFocus = (focusIn) => {
        if (isNullOrUndefined(this.props.searchForm.focus) || this.props.searchForm.focus === this.props.name)
            this.props.setSearchInputFocus(focusIn ? this.props.name : null)
    }

    canHighlightError = () => {
        const { formik, name, searchForm } = this.props;

        if (isNullOrUndefined(formik.errors[name]))
            return false;

        if (isNullOrUndefined(searchForm.focus))
            return true;

        if (!isNullOrUndefined(searchForm.focus)) {
            if (searchForm.focus === name)
                return true;

            const focusError = formik.errors[searchForm.focus]
            if (isNullOrUndefined(focusError) || isString(focusError))
                return false;

            if (focusError.hasOwnProperty("related") && Array.isArray(focusError.related) && focusError.related.includes(name))
                return true;
        }

        return false;
    }

    getErrorMessage = (e) => {
        if (isNullOrUndefined(e))
            return "";

        if (isString(e))
            return e;

        if (e.hasOwnProperty("message"))
            return e.message;

        return "";
    }

    isMinCriteriaError = (e) => {
        if (isNullOrUndefined(e))
            return false;

        if (e.hasOwnProperty("related") && !e.hasOwnProperty("message"))
            return true;

        return false;
    }
}

export default connect(
    state => ({ searchForm: state.repi.searchForm, search: state.repi.search }),
    dispatch => bindActionCreators(repiActions, dispatch),
)(RepiSearchInput);